import { TAG_TYPES } from 'types/services';

import { heliosApi } from '.';

export interface FavoriteTemplateResponse {
  id: string;
  userId: string;
  templateId: string;
  created: string;
}

export interface FavoriteTemplatesResponse {
  favoriteTemplates: FavoriteTemplateResponse[];
}

export const heliosFavoriteTemplatesService = heliosApi.injectEndpoints({
  endpoints: (builder) => ({
    getFavoriteTemplates: builder.query<FavoriteTemplatesResponse, void>({
      query: () => ({
        url: 'FavoriteTemplates',
        method: 'GET',
      }),
      providesTags: [TAG_TYPES.FAVORITE_TEMPLATES],
    }),
    setFavoriteTemplate: builder.mutation<FavoriteTemplateResponse, string>({
      query: (templateId) => ({
        url: 'FavoriteTemplates',
        method: 'POST',
        params: { TemplateId: templateId },
      }),
      invalidatesTags: [TAG_TYPES.FAVORITE_TEMPLATES],
    }),
    removeFavoriteTemplate: builder.mutation<void, string>({
      query: (id) => ({
        url: `FavoriteTemplates/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: [TAG_TYPES.FAVORITE_TEMPLATES],
    }),
  }),
});
export const { useGetFavoriteTemplatesQuery, useSetFavoriteTemplateMutation, useRemoveFavoriteTemplateMutation } = heliosFavoriteTemplatesService;
